import { Injectable } from '@angular/core';
import { Campaign} from '@core/interfaces/catalogos.intefaces';
import { Request } from '@core/models/requests.model';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {

  private url = `ventas/catalogos/segmentacion/campania/search`;

  constructor(
    private request:Request
  ) { }

  getCampaign(body:any) {
    const options = { headers: this.request.headers };
    return this.request.Post<Campaign>( this.url,body, options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string): { key: any; value: any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp] }));
  }


}

